<div class="section-container justify-content background">
  <span class="section-title">{{ headerText }}</span>
  <div class="section-actions">
    @if (showRefreshButton) {
      <button
        mat-icon-button
        type="button"
        (click)="onRefresh()"
        [disabled]="refreshing"
        [ngClass]="refreshing ? 'refreshing' : ''"
        aria-label="Refresh"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    }
    @if (!hideAddButton) {
      <button mat-button color="primary" (click)="add()" aria-label="Add New">
        <mat-icon>add</mat-icon>
        <span class="action-text">Add New</span>
      </button>
    }
    @if (!hideCollapseButton) {
      <button
        mat-button
        color="primary"
        type="button"
        (click)="toggleCollapsed()"
        [attr.aria-expanded]="!collapsed"
        [attr.aria-label]="collapsed ? 'Expand section' : 'Collapse section'"
      >
        <mat-icon>{{ collapsed ? 'chevron_right' : 'expand_more' }}</mat-icon>
        <span class="action-text">{{ collapsed ? 'Expand' : 'Collapse' }}</span>
      </button>
    }
  </div>
</div>
@if (!collapsed) {
  <ng-content></ng-content>
}
